import { FC } from 'react';
import Skeleton from 'antd/lib/skeleton/Skeleton';

import { SettingsFormItemSkeletonStyled } from 'components/Skeletons/Settings/styled';

const SettingsFormItemSkeleton: FC = () =>
  <SettingsFormItemSkeletonStyled>
    <Skeleton title paragraph={false} />
    <Skeleton.Input active size="large" />
  </SettingsFormItemSkeletonStyled>;

export default SettingsFormItemSkeleton;
